<template>
  <div
    class="flex flex-col p-6 shadow-sm-1 rounded-lg bg-white"
    :data-testid="dataTestid"
  >
    <AtomsImage
      class="m-auto"
      src="/images/dail-up-savings.svg"
      width="140"
      height="140"
      alt="Dail up savings"
    />

    <p class="font-bold text-lg m-auto text-center mt-4">
      Dial up your savings
      with Club+
    </p>

    <p class="text-sm m-auto text-center mt-2">
      Take control of your bills, discover savings and enjoy member-only perks.
    </p>

    <atoms-button
      size="medium"
      theme="primary"
      class="mt-2"
      to="/register/?utm_source=internal-clubplus&utm_medium=internal&utm_campaign=internal_guidepage_registration&utm_content=clubplus"
      :has-icon="false"
      icon-direction="right"
      :full="true"
      :enable-tracking="true"
    >
      Join now
    </atoms-button>
  </div>
</template>

<script setup>

defineOptions({
  name: 'MoleculesJoinClubPlus'
})

defineProps({
  dataTestid: {
    type: String,
    default: ''
  }
})
</script>
